module.exports = __webpack_public_path__ + "static/media/Conneightion.74ba9f78.png";